'use client'

import { styled, TextField } from '@mui/material'

export const ValueTextField = styled(TextField)(({ theme }) => ({
  padding: 0,
  width: theme.spacing(5),
  maxWidth: theme.spacing(5),
  minWidth: theme.spacing(5),
  '&.MuiFormControl-root.favoriteBusiness': {
    width: theme.spacing(7),
    maxWidth: theme.spacing(7),
    minWidth: theme.spacing(7),
  },
  '& .MuiInput-root': {
    height: theme.spacing(5),
    '&::before, &::after': {
      content: 'unset',
    },
    input: {
      textAlign: 'center',
    },
  },
}))
